export default function(src) {
  return new Promise(resolve => {
    const image = document.createElement('img')
    image.addEventListener('load', () => {
      resolve(src)
    }, { once: true })
    image.src = src
  })
}